module.exports = __webpack_public_path__ + "static/media/london.ede53a61.jpg";